import React from "react";
import { useDimensions } from "../../Util";

const AdsContainer = () => {

    const {w,h} = useDimensions();

    const Styles = {
        adsContainer:{
            gridRow: w > h ? "1 / 17" : "20/28",
            gridColumn: w > h ? "38 / 51" : "1/51",
            display: "flex",
            background:"#393E46",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap:"7px"
        },
        container1:{
            width:"48%",
            height:w>h?"96%":"90%",
            background:"#FCE38A",
            position:"relative"
        },
        container2:{
            width:"48%",
            height:w>h?"96%":"90%",
            background:"#F38181",
            position:"relative"
        },
        largeImage: {
            width: "100%",
            height: "100%",
        },
        ltb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(25px,2.5vw,30px)" : "clamp(25px,2.5vh,30px)",
            color:"#222831"
        },
        ltbw: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(25px,2.5vw,30px)" : "clamp(18px,2.15vh,25px)",
            color:w>h?"#222831":"#EEEEEE"
        },
        ltn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(22px,2.25vw,25px)" : "clamp(22px,2.25vh,25px)",
        },
        smallImage: {
            width: w > h ? 8 * h : 5 * h,
            height: w > h ? 8 * h : 5 * h,
        },
        circularImage: {
            width: w > h ? 5 * h : 5 * h,
            height: w > h ? 5 * h : 5 * h,
            borderRadius: "50%"
        },
        mtb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(20px,2vw,25px)" : "clamp(13px,1.15vh,25px)",
            color:"#0F4C75"
        },
        mtn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(15px,1.25vw,20px)" : "clamp(15px,1.25vh,20px)"
        },
        stb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(12px,1.25vw,15px)" : "clamp(12px,1.25vh,15px)"        
        },
        stn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(11px,1.15vw,13px)" : "clamp(11px,1.15vh,13px)",
            color:"#3282B8" 
        },
        xstn: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(12px,1.25vw,15px)" : "clamp(12px,1.25vh,15px)",
            color:"#222831",
            opacity:0.5
        },
        xltb: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(38px,4vw,50px)" : "clamp(38px,4vh,50px)",
        },
        btn: {
            padding: "7px",
            background: "#00ADB5",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 1.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer",
            fontWeight:600
        },
        btnLater: {
            padding: "7px",
            background: "#393E46",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 1.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer"
        },
        btnDisabled: {
            padding: "7px",
            background: "#9DB2BF",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 2 * h,
            fontFamily: "Candal",
            marginInline: "5px",
            cursor: "not-allowed"
        },
        flexDivRow:{
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            flexDirection:"row",
            height:"95%",
            width:"95%"
        },
        flexDivCol:{
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            flexDirection:"column",
            height:"95%",
            width:"95%"
        }

    }

    return <div style={Styles.adsContainer}>
        <div style={Styles.container1}>
        <p style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "3px 5px",
                    borderRadius: "3px",
                    fontSize: "10px"
            }}>
            Sponcered
        </p>
        {
            w>h?(
                    <img src={"/images/bankad.png"} style={Styles.largeImage} alt="Description" />
            ):(
                    <img src={"/images/banadmob.png"} style={Styles.largeImage} alt="Description" />
            )
        }
        </div>
        
        <div style={Styles.container2}>
        <p style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "3px 5px",
                    borderRadius: "3px",
                    fontSize: "10px"
            }}>
            Sponcered
        </p>
        {
            w>h?(
                    <img src={"/images/dmat.png"} style={Styles.largeImage} alt="Description" />
            ):(
                    <img src={"/images/dmatmob.png"} style={Styles.largeImage} alt="Description" />
            )
        }
        </div>
        
    </div>
}

export default AdsContainer;